import { UiTableConfig } from '@ui-kit/table/_core';
import { FeeWaiverAuditLogTableColumnEnum, feeWaiverAuditLogTableColumnText } from '../types';

export function feeWaiverAuditLogTableConfig(): UiTableConfig<FeeWaiverAuditLogTableColumnEnum, any> {
    return {
        dataTrackBy: 'id',
        hasEmptyEnd: false,
        emptyStateText: 'groups.feeWaivers.auditLog.emptyState',
        columns: [
            {
                field: FeeWaiverAuditLogTableColumnEnum.TYPE,
                key: 'actionTypeText',
                name: feeWaiverAuditLogTableColumnText[FeeWaiverAuditLogTableColumnEnum.TYPE],
                centered: false,
                width: '105px',
                minWidth: '105px',
                maxWidth: '105px',
                isVisible: true,
                widthRatio: 1,
                customTemplate: 'actionType',
            },
            {
                field: FeeWaiverAuditLogTableColumnEnum.PREVIOUS_VALUE,
                key: 'previousValue',
                name: feeWaiverAuditLogTableColumnText[FeeWaiverAuditLogTableColumnEnum.PREVIOUS_VALUE],
                centered: false,
                width: '20vw',
                minWidth: '150px',
                maxWidth: '150px',
                isVisible: true,
                widthRatio: 1,
            },
            {
                field: FeeWaiverAuditLogTableColumnEnum.NEW_VALUE,
                key: 'newValue',
                name: feeWaiverAuditLogTableColumnText[FeeWaiverAuditLogTableColumnEnum.NEW_VALUE],
                centered: false,
                width: '20vw',
                minWidth: '150px',
                maxWidth: '150px',
                isVisible: true,
                widthRatio: 1,
            },
            {
                field: FeeWaiverAuditLogTableColumnEnum.MODIFIED_BY,
                key: 'modifiedBy',
                name: feeWaiverAuditLogTableColumnText[FeeWaiverAuditLogTableColumnEnum.MODIFIED_BY],
                centered: false,
                width: '20vw',
                minWidth: '150px',
                maxWidth: '150px',
                isVisible: true,
                widthRatio: 1,
                customTemplate: 'modifiedBy',
            },
            {
                field: FeeWaiverAuditLogTableColumnEnum.TIMESTAMP,
                key: 'dateModified',
                name: feeWaiverAuditLogTableColumnText[FeeWaiverAuditLogTableColumnEnum.TIMESTAMP],
                centered: false,
                width: '135px',
                minWidth: '135px',
                maxWidth: '135px',
                isVisible: true,
                widthRatio: 1,
                dateTimeInfo: true,
                dateTimeShowTime: true,
            },
        ],
    };
}
